














































import Vue from 'vue'
import { EditPattern } from '@/search/types'
import FilterItem from '@/search/components/FilterItem.vue'
import HeaderSection from '@/search/components/HeaderSection.vue'

export default Vue.extend({
  components: {
    FilterItem,
    HeaderSection
  },
  props: {
    editPatternList: {
      type: Array as () => EditPattern[],
      required: true
    },
    searchEditPatterns: {
      type: Array as () => string[],
      required: true
    }
  },
  data(): {
    selectedEditPatterns: string[]
    contentVisible: boolean
  } {
    return {
      contentVisible: false,
      selectedEditPatterns: [...this.searchEditPatterns]
    }
  },
  computed: {
    selectedMethodLabel(): string {
      return this.selectedEditPatterns.map(item => this.editPatternList.find(pattern => pattern.editPatternName === item)?.editPatternDisplayName).join('/')
    }
  },
  methods: {
    toggleContent() {
      this.contentVisible = !this.contentVisible
    },
    onChangeSelection() {
      this.$emit('updateParams', {
        editPatterns: this.selectedEditPatterns
      })
    }
  }
})
